import { LinkButton, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CPD1000Banner.css';

export interface ICPD1000BannerProps {
  url: string;
  onClick(): void;
}

export function CPD1000Banner(props: ICPD1000BannerProps) {
  return (
    <div className={styles['banner']} data-name="CPD1000Banner">
      <div className={styles['header']}>
        <UIHeading1 color="text-inverted-default">1000 сделок, где всё удалось</UIHeading1>
      </div>
      <div className={styles['text']}>
        <UIText1 color="text-inverted-default">
          Узнайте, как Циан помогает продавать и покупать недвижимость на вторичке
        </UIText1>
      </div>
      <LinkButton theme="fill_white_primary" size="M" href={props.url} onClick={props.onClick}>
        Подробнее
      </LinkButton>
    </div>
  );
}
